import { render, staticRenderFns } from "./SocialConnected.vue?vue&type=template&id=6aa4f45d&scoped=true"
import script from "./SocialConnected.vue?vue&type=script&lang=js"
export * from "./SocialConnected.vue?vue&type=script&lang=js"
import style0 from "./SocialConnected.vue?vue&type=style&index=0&id=6aa4f45d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa4f45d",
  null
  
)

export default component.exports